__turbopack_context__.v({
  "about-block": "LcvRouteLandingPage-module-scss-module__QIAjTa__about-block",
  "about-text": "LcvRouteLandingPage-module-scss-module__QIAjTa__about-text",
  "about-title": "LcvRouteLandingPage-module-scss-module__QIAjTa__about-title",
  "block-title": "LcvRouteLandingPage-module-scss-module__QIAjTa__block-title",
  "btn-primary": "LcvRouteLandingPage-module-scss-module__QIAjTa__btn-primary",
  "chip": "LcvRouteLandingPage-module-scss-module__QIAjTa__chip",
  "chip-block": "LcvRouteLandingPage-module-scss-module__QIAjTa__chip-block",
  "chip-label": "LcvRouteLandingPage-module-scss-module__QIAjTa__chip-label",
  "chip-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__chip-row",
  "cols-2": "LcvRouteLandingPage-module-scss-module__QIAjTa__cols-2",
  "contact-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__contact-row",
  "dhaba-card": "LcvRouteLandingPage-module-scss-module__QIAjTa__dhaba-card",
  "dhaba-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__dhaba-row",
  "dropLocationField": "LcvRouteLandingPage-module-scss-module__QIAjTa__dropLocationField",
  "eyebrow-kw": "LcvRouteLandingPage-module-scss-module__QIAjTa__eyebrow-kw",
  "faq-answer": "LcvRouteLandingPage-module-scss-module__QIAjTa__faq-answer",
  "faq-block": "LcvRouteLandingPage-module-scss-module__QIAjTa__faq-block",
  "faq-item": "LcvRouteLandingPage-module-scss-module__QIAjTa__faq-item",
  "feature-item": "LcvRouteLandingPage-module-scss-module__QIAjTa__feature-item",
  "feature-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__feature-row",
  "fg-label": "LcvRouteLandingPage-module-scss-module__QIAjTa__fg-label",
  "fg-links": "LcvRouteLandingPage-module-scss-module__QIAjTa__fg-links",
  "fg-more": "LcvRouteLandingPage-module-scss-module__QIAjTa__fg-more",
  "fg-text": "LcvRouteLandingPage-module-scss-module__QIAjTa__fg-text",
  "field": "LcvRouteLandingPage-module-scss-module__QIAjTa__field",
  "fieldInteractive": "LcvRouteLandingPage-module-scss-module__QIAjTa__fieldInteractive",
  "footer-app": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-app",
  "footer-bottom": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-bottom",
  "footer-brand": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-brand",
  "footer-group": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-group",
  "footer-logo-svg": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-logo-svg",
  "footer-made": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-made",
  "footer-seo-text": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-seo-text",
  "footer-social": "LcvRouteLandingPage-module-scss-module__QIAjTa__footer-social",
  "headline-1": "LcvRouteLandingPage-module-scss-module__QIAjTa__headline-1",
  "headline-2": "LcvRouteLandingPage-module-scss-module__QIAjTa__headline-2",
  "hero": "LcvRouteLandingPage-module-scss-module__QIAjTa__hero",
  "hero-actions": "LcvRouteLandingPage-module-scss-module__QIAjTa__hero-actions",
  "hero-form-card": "LcvRouteLandingPage-module-scss-module__QIAjTa__hero-form-card",
  "hero-h1": "LcvRouteLandingPage-module-scss-module__QIAjTa__hero-h1",
  "hero-sub": "LcvRouteLandingPage-module-scss-module__QIAjTa__hero-sub",
  "is-visible": "LcvRouteLandingPage-module-scss-module__QIAjTa__is-visible",
  "load-form": "LcvRouteLandingPage-module-scss-module__QIAjTa__load-form",
  "loc": "LcvRouteLandingPage-module-scss-module__QIAjTa__loc",
  "local-block": "LcvRouteLandingPage-module-scss-module__QIAjTa__local-block",
  "local-note": "LcvRouteLandingPage-module-scss-module__QIAjTa__local-note",
  "logo-link": "LcvRouteLandingPage-module-scss-module__QIAjTa__logo-link",
  "logo-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__logo-row",
  "logo-svg": "LcvRouteLandingPage-module-scss-module__QIAjTa__logo-svg",
  "more-toggle": "LcvRouteLandingPage-module-scss-module__QIAjTa__more-toggle",
  "name": "LcvRouteLandingPage-module-scss-module__QIAjTa__name",
  "num": "LcvRouteLandingPage-module-scss-module__QIAjTa__num",
  "page": "LcvRouteLandingPage-module-scss-module__QIAjTa__page",
  "pageBn": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageBn",
  "pageGu": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageGu",
  "pageHi": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageHi",
  "pageKn": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageKn",
  "pageTa": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageTa",
  "pageTe": "LcvRouteLandingPage-module-scss-module__QIAjTa__pageTe",
  "pickupLocationField": "LcvRouteLandingPage-module-scss-module__QIAjTa__pickupLocationField",
  "price-link": "LcvRouteLandingPage-module-scss-module__QIAjTa__price-link",
  "proof-card": "LcvRouteLandingPage-module-scss-module__QIAjTa__proof-card",
  "proof-label": "LcvRouteLandingPage-module-scss-module__QIAjTa__proof-label",
  "site-footer": "LcvRouteLandingPage-module-scss-module__QIAjTa__site-footer",
  "site-header": "LcvRouteLandingPage-module-scss-module__QIAjTa__site-header",
  "stat-cell": "LcvRouteLandingPage-module-scss-module__QIAjTa__stat-cell",
  "stat-grid": "LcvRouteLandingPage-module-scss-module__QIAjTa__stat-grid",
  "stat-label": "LcvRouteLandingPage-module-scss-module__QIAjTa__stat-label",
  "stat-num": "LcvRouteLandingPage-module-scss-module__QIAjTa__stat-num",
  "step-num": "LcvRouteLandingPage-module-scss-module__QIAjTa__step-num",
  "step-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__step-row",
  "step-text": "LcvRouteLandingPage-module-scss-module__QIAjTa__step-text",
  "steps-block": "LcvRouteLandingPage-module-scss-module__QIAjTa__steps-block",
  "steps-title": "LcvRouteLandingPage-module-scss-module__QIAjTa__steps-title",
  "sticky-cta": "LcvRouteLandingPage-module-scss-module__QIAjTa__sticky-cta",
  "tag": "LcvRouteLandingPage-module-scss-module__QIAjTa__tag",
  "tag-row": "LcvRouteLandingPage-module-scss-module__QIAjTa__tag-row",
  "trust-strip": "LcvRouteLandingPage-module-scss-module__QIAjTa__trust-strip",
  "wrap-footer": "LcvRouteLandingPage-module-scss-module__QIAjTa__wrap-footer",
});
